/**
 * Simple replacement for the gmap package
 * Provides Google Maps directions functionality without Node.js dependencies
 */

const gmap = {
  /**
   * Generate Google Maps directions URL
   * @param {string} origin - Origin coordinates (lat,lng)
   * @param {string} destination - Destination coordinates (lat,lng)
   * @returns {string} Google Maps directions URL
   */
  directions: (origin, destination) => {
    const baseUrl = 'https://www.google.com/maps/dir/';
    const encodedOrigin = encodeURIComponent(origin);
    const encodedDestination = encodeURIComponent(destination);
    return `${baseUrl}${encodedOrigin}/${encodedDestination}`;
  }
};

export default gmap;
